"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryLogs = void 0;

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryLogs = new _CrudBuilder.CrudBuilder(class BasisTheoryLogs extends _service.BasisTheoryService {}).list().build();
exports.BasisTheoryLogs = BasisTheoryLogs;